import Sentry from '@/services/sentry'

export const loaderCreator = (loader) => () => {
  try {
    loader()
  } catch (error) {
    Sentry.captureException(new Error('Init 3rd party inside vuex plugin'), {
      extra: {
        error,
      },
    })
  }
}
